import React, { Component } from 'react';

class MerchantSelection extends Component {
    render() {
        const { merchants, handleMerchantSelection } = this.props;

        return (
            <div>
                <h2 className="text-center m-t-5 m-b-20">Select Merchant</h2>
                {
                    merchants.map(function (m) {
                        return (
                            <div className="card-slim text-center" key={m.merchantId} onClick={handleMerchantSelection.bind(this, m)}>
                                <p><b>{m.name}</b></p>
                                <span>{m.merchantId}</span>
                            </div>
                        );
                    }.bind(this))
                }
            </div>
        );
    }
}

export default MerchantSelection;


// WEBPACK FOOTER //
// ./app/auth/components/merchantSelection.js